import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
export type TextSize = 'sm' | 'md' | 'lg';
interface TextSizeContextValue {
  size: TextSize;
  setSize: (size: TextSize) => void;
}
const TextSizeContext = createContext<TextSizeContextValue>({
  size: 'sm',
  setSize: () => {}
});
const classes: Record<TextSize, string> = {
  sm: '',
  md: 'text-size-md',
  lg: 'text-size-lg'
};

/**
 * Sélecteur « A A A » de l'en-tête de Beaconsfield.
 *
 * Agit sur la taille de police de la racine : toutes les tailles Tailwind étant en rem,
 * elles suivent. Les hauteurs du hero sont elles aussi en rem, pour grandir avec le texte
 * au lieu de le laisser déborder.
 */
export function TextSizeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [size, setSize] = useState<TextSize>('sm');
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('text-size-md', 'text-size-lg');
    if (classes[size]) root.classList.add(classes[size]);
  }, [size]);
  const value = useMemo(() => ({
    size,
    setSize
  }), [size]);
  return <TextSizeContext.Provider value={value} data-id="element-2872" data-mp="2ck2dqa7wj9el">{children}</TextSizeContext.Provider>;
}
export function useTextSize(): TextSizeContextValue {
  return useContext(TextSizeContext);
}